import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { PortalHeader } from './components/header/portal-header';
import { LandingPage } from './pages/LandingPage';
import { AppPage } from './pages/AppPage';
import { GlobalToast } from './components/global-toast/global-toast';
import {
  MimicBar,
  LoadingSpinner,
  getJwt,
} from '@spins-gcp/shared-components-react';
import { isTokenExpired } from '@spins-gcp/auth0-react';
import { JwtPayload } from 'jwt-decode';
import { MimicModal } from './components/mimic-modal/mimic-modal';
import { ArrowLeftRight } from 'lucide-react';
import styles from './app.module.scss';
import { useMimic } from './hooks/useMimic';

function App() {
  const navigate = useNavigate();
  const { setMimicUser, mimicUser, isMimic, setShowMimicModal, status } =
    useMimic();
  const isMimicLoading = status === 'loading';

  return (
    <>
      {isMimic && (
        <MimicBar
          mimicUser={mimicUser}
          setMimicUser={
            /* istanbul ignore next */ (val) => {
              if (val === undefined) {
                const token = getJwt();
                const isExpired = token
                  ? isTokenExpired(token as JwtPayload)
                  : undefined;
                if (isExpired || isExpired === undefined) {
                  window.location.assign('/');
                  return;
                }
                navigate('/');
              }
              setMimicUser?.(undefined);
            }
          }
          mimicButton={
            <button
              data-testid="switch-btn"
              className={styles['mimic-switch-button']}
              onClick={() => setShowMimicModal(true)}
            >
              <ArrowLeftRight size={12} />
              Switch
            </button>
          }
        />
      )}
      <MimicModal />
      <PortalHeader />
      {isMimicLoading && (
        <div className={styles['mimic-loading-overlay']}>
          <LoadingSpinner />
        </div>
      )}
      <Routes>
        <Route path="/:slug" element={<AppPage />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
      <GlobalToast />
    </>
  );
}

export default App;
